import { QR_KEYS } from '@config/constant';
import { QrKey } from '@store/qrVerificationStore';

export interface DecodedQRData {
	membershipNumber: string | null;
	timestamp: string | null;
	originalData: string;
	decryptedData: string | null;
	isValid: boolean;
}

export interface DecryptionConfig {
	readonly algorithm: string | undefined;
	readonly key: string | undefined;
	readonly iv: string | undefined;
}

export interface SiteVisitPayload {
	status: boolean;
}

export const QR_TIME_TOLERANCE_MS = 10000;

export interface IVisitCompleteQrProps {
	siteDetails: { membershipno?: string } | null | undefined;
	verificationKey: keyof typeof QR_KEYS | (typeof QR_KEYS)[keyof typeof QR_KEYS];
}

export const resolveQrStoreKey = (vk: IVisitCompleteQrProps['verificationKey']): QrKey => {
	if (vk === QR_KEYS.SITE) return QR_KEYS.SITE;
	return QR_KEYS.SITE;
};
